import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidFlag",
  "use": "SolidFlag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"SolidFlag\"><defs><path d=\"M13.833 6.99h4.227c.517 0 .94.312.94.829v7.217c0 .516-.423.94-.94.94h-4.772a.928.928 0 0 1-.921-.753l-.226-1.255H6.88v5.066H5V5.94c0-.517.423-.94.94-.94h6.746c.451 0 .836.32.921.752l.226 1.239zM5 19.035h1.88a.94.94 0 1 1-1.88 0z\" id=\"SolidFlag_solid-flag\" /></defs><use xlink:href=\"#SolidFlag_solid-flag\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol